import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../card-background-view-model';
import { Observable } from 'rxjs';
import { NycdCardData } from '../../../../../../../models/print-cards/nycd-card-data';

@Injectable()
export class NycdIndexCardStackBackgroundViewModel extends CardBackgroundViewModel {
  public override cardData$: Observable<NycdCardData>;
}
